module.exports = __webpack_public_path__ + "img/customer.04fd3c68.svg";